<script lang="ts">
  import { setContext } from "svelte"
  import { writable } from "svelte/store"
  import { cn } from "$lib/utils"
  import type { TabsContext } from "./types"

  export let value: string | undefined = undefined
  export let defaultValue: string | undefined = undefined
  export let onValueChange: ((value: string) => void) | undefined = undefined
  let className = ""
  export { className as class }

  const selectedValue = writable(value || defaultValue || "")

  function selectTab(newValue: string) {
    selectedValue.set(newValue)
    if (onValueChange) {
      onValueChange(newValue)
    }
  }

  $: if (value !== undefined) {
    selectedValue.set(value)
  }

  setContext<TabsContext>("tabs", {
    selectedValue,
    selectTab,
  })
</script>

<div class={cn("", className)} {...$$restProps}>
  <slot />
</div>
